import SwalAlert from 'Global/Components/CommonComponents/SwalAlert/SwalAlert';
import axios from 'axios';
const AxiosInstance = (
  method,
  url,
  Authentication,
  data
) => {
  let token = JSON.parse(localStorage.getItem('AuthToken'));
  const IsAuth = {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
    'DotNet-Timeout': 30000,
  };
  const IsNotAuth = {
    'Content-Type': 'application/json',
    'DotNet-Timeout': 30000,
  };
  return axios.create({
    method,
    url,
    headers: Authentication ? IsAuth : IsNotAuth,
    data: JSON.stringify(data),
  });
};

export const Post = async (
  method,
  url,
  Authentication,
  data = {}
) => {
  const axios = AxiosInstance(method, url, Authentication);
  try {
    const response = await axios.post(url, data);
    if (
      response.data.resCode &&
      response.data.resCode !== 1
    ) {
      console.clear();
      console.error(
        'error',
        `Server error at endpoint ${url}`,
        false
      );
    }
    return response;
  } catch (error) {
    if (
      error.code === 'ECONNABORTED' ||
      (error.response && error.response.status === 504)
    ) {
      // SwalAlert(
      //   'error',
      //   'Request timed out. Please try again.',
      //   false
      // );
    } else {
      console.clear();
      console.error('error', error.message, false);
    }
    throw error; // Re-throw the error for further handling if needed
  }
};

export const Get = async (
  url,
  isAuthenticated,
  data = {}
) => {
  const instance = AxiosInstance(
    'get',
    url,
    isAuthenticated
  );
  try {
    const response = await instance.get(url, data);
    if (
      response.data.resCode &&
      response.data.resCode !== 1
    ) {
      console.clear();
      console.error(
        'error',
        `Server error at endpoint ${url}`,
        false
      );
    }
    return response;
  } catch (error) {
    if (
      error.code === 'ECONNABORTED' ||
      (error.response && error.response.status === 504)
    ) {
      // SwalAlert(
      //   'error',
      //   'Request timed out. Please try again.',
      //   false
      // );
    } else {
      console.clear();
      console.error('error', error.message, false);
    }
    throw error; // Re-throw the error for further handling if needed
  }
};
